import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-data-integration',
  templateUrl: './data-integration.component.html',
  styleUrls: ['./data-integration.component.sass']
})
export class DataIntegrationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
